import "./App.scss";
import React from "react";
import { GoogleMap, LoadScript, MarkerClusterer, Marker } from "@react-google-maps/api";
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon } from "react-share";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import Search from "./components/Search.js";
import Pages from "./components/Pages.js";
import WelcomeBoard from "./components/WelcomeBoard.js";

// Data import
import cmaster from "./data/cmaster.json";
import wp_entries from "./data/wp-entries.json";
import mapskin from "./components/mapskin.js";

//images
import logo from "./images/sma_logo.png";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.PageRef = React.createRef();

    this.state = {
      mangaList: wp_entries.reverse(),
      searchKeyword: "",
      searchKeywordReady: "",
      toggle: {
        welcomeBoard: true,
        searchResult: false,
        contentsList: false,
      },
      gmap: {
        defaultProps: {
          center: {
            lat: 36.0,
            lng: 138.0,
          },
          zoom: 3,
        },
        mapContainerStyle: {
          height: "100%",
          width: "100%",
        },
        locations: null,
        clusters_options: {
          minimumClusterSize: 1,
          styles: [
            {
              // 1ケタ代
              url: process.env.PUBLIC_URL + "/images/c42.png",
              width: 42,
              height: 42,
              textColor: "#ffffff",
              textSize: 14,
              fontWeight: "normal",
            },
            {
              // 2ケタ代
              url: process.env.PUBLIC_URL + "/images/c56.png",
              width: 56,
              height: 56,
              textColor: "#ffffff",
              textSize: 16,
              fontWeight: "normal",
            },
            {
              // 3ケタ代
              url: process.env.PUBLIC_URL + "/images/c72.png",
              width: 72,
              height: 72,
              textColor: "#ffffff",
              textSize: 22,
              fontWeight: "bold",
            },
          ],
        },
      },
    };

    /**
     * <Marker> and <MarkerCluster>'s prop
     */
    let locCount = {};

    // no need to rerendering : this.setState()
    this.state.gmap.locations = wp_entries.map((entry) => {
      let country = cmaster[entry.code];
      if (country === undefined) country = cmaster["JP"];

      // マーカーに国クラスタ内での通し番(インクリメント値)を付与
      let locKey = country.lat + " " + country.lon;

      if (!(locKey in locCount)) locCount[locKey] = 1;
      else locCount[locKey]++;

      let location = circle(country.lat, country.lon, locCount[locKey], entry.code);

      return {
        lat: location[0] / 1,
        lng: location[1] / 1,
        entry: entry,
      };

      function circle(lat, long, i, code) {
        // 起点の座標
        lat = parseFloat(lat) - 0.4; // 縦の起点を調整
        long = parseFloat(long) - 1.6; // 横の起点を調整
        //i = (i === 1) ? 0 : i + 1; //通し番号
        let n = 10; // １週目に配置する数
        let r = i * (360 / n); // ずらし角度

        // 起点からの距離(分母が小さいほど間隔が開く)
        let a = i / 0.08;

        return [lat + (Math.sin(r) + Math.sin(a)), long + (Math.cos(r) + Math.cos(a))];
      }
    });
  }

  componentDidMount() {}

  /**
   *
   * Toggle elm
   *
   */

  toggleElements = (e, bool) => {
    let target = e.currentTarget.getAttribute("data-toggle");
    this.setState({ toggle: { [target]: bool } });
  };

  toggleClass = (state) => {
    return state ? "open" : "close";
  };

  handleApiLoaded = (map, maps) => {};

  onMarkerClustererClick = (markerClusterer) => {
    const clickedMarkers = markerClusterer.getMarkers();
    this.setState({ toggle: { contentsList: true } });
    this.PageRef.current.pageReflesh();
    this.setState({
      mangaList: clickedMarkers.map((marker) => {
        return marker.entry;
      }),
    });
    // console.log("Current clicked markers length",clickedMarkers.length)
    // console.log(this.state.mangaList)
  };

  render() {
    return (
      <>
        <div id="world-map">
          <div id="map-container">
            <div id="map" style={{ height: "100%", width: "100%" }}>
              <LoadScript googleMapsApiKey={process.env.REACT_APP_GGL_KEY}>
                <GoogleMap
                  //bootstrapURLKeys={{ key: process.env.REACT_APP_GGL_KEY }}
                  center={this.state.gmap.defaultProps.center}
                  zoom={this.state.gmap.defaultProps.zoom}
                  yesIWantToUseGoogleMapApiInternals
                  onLoad={({ map, maps }) => this.handleApiLoaded(map, maps)}
                  options={{
                    styles: mapskin,
                    minZoom: 2,
                    maxZoom: 8,
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                  }}
                  id="marker-example"
                  mapContainerStyle={this.state.gmap.mapContainerStyle}
                >
                  <MarkerClusterer
                    zoomOnClick={false}
                    options={this.state.gmap.clusters_options}
                    onClick={this.onMarkerClustererClick.bind(this)}
                  >
                    {(clusterer) =>
                      this.state.gmap.locations.map((location) => (
                        <Marker
                          options={{ entry: location.entry }}
                          key={location.lat + "-" + location.lng}
                          position={location}
                          clusterer={clusterer}
                          mouseover={(e) => console.log("on")}
                          mouseout={(e) => console.log("off")}
                        />
                      ))
                    }
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            </div>
          </div>
          {/* map-container */}

          {/**
           *
           *  CONTENTS LIST
           *
           */}
          <div
            id="content-wrap"
            className={"clearfix " + this.toggleClass(this.state.toggle.contentsList)}
          >
            <div className="swiper-container">
              <div
                className="closeList"
                onClick={(e) => this.setState({ toggle: { contentsList: false } })}
              >
                <i className="far fa-times-circle"></i>
              </div>
              <div className="content-inner-wrap">
                <Pages list={this.state.mangaList} ref={this.PageRef} />
              </div>
            </div>
            {/* #content */}
          </div>
          {/* content-wrap */}

          {/**
           *
           *  TOOL BAR
           *
           */}
          <ul id="tool-btn">
            <li className="logo-btn">
              <a href="https://www.manga-audition.com">
                <img src={logo} alt="SMA Homepege" />
              </a>
            </li>
            <li className="share-btn s_facebook">
              <FacebookShareButton
                url={["https://smacmag.net/map/"]}
                quote={["Read All Silent Manga From All Over The World!"]}
              >
                <i className="fab fa-facebook"></i>
              </FacebookShareButton>
            </li>
            <li className="share-btn s_twitter">
              <TwitterShareButton
                url={["https://smacmag.net/map/"]}
                title={["Read All Silent Manga From All Over The World!"]}
              >
                <i className="fab fa-twitter"></i>
              </TwitterShareButton>
            </li>
          </ul>

          {/**
           *
           *  SERACH FUNCTION
           *
           */}
          <div id="searchbar-area">
            <div id="search">
              <input
                id="search_text"
                type="text"
                value={this.state.searchKeyword}
                placeholder="title,creator,etc.."
                name="search_entry"
                data-toggle="searchResult"
                onChange={(e) => {
                  this.setState({ searchKeyword: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    this.toggleElements(e, true);
                    this.setState({ searchKeywordReady: this.state.searchKeyword });
                  }
                }}
              />
              <button
                id="search_btn"
                data-toggle="searchResult"
                onClick={(e) => {
                  this.toggleElements(e, true);
                  this.setState({ searchKeywordReady: this.state.searchKeyword });
                }}
              >
                <i className="fas fa-search"></i>
              </button>
            </div>
          </div>
          {/* searchbar area */}

          <SimpleBar
            id="search_result"
            className={this.toggleClass(this.state.toggle.searchResult)}
          >
            <div className="search_result_close_wrap">
              <div
                id="search_result_close"
                data-toggle="search_result"
                onClick={(e) => {
                  this.toggleElements(e, false);
                }}
              >
                <i className="far fa-times-circle"></i>
              </div>
            </div>
            <Search keyword={this.state.searchKeywordReady} entries={wp_entries} />
          </SimpleBar>

          <div
            id="modal"
            className={this.toggleClass(this.state.toggle.welcomeBoard)}
            onClick={(e) => {
              this.toggleElements(e, false);
            }}
          >
            <WelcomeBoard />
          </div>
        </div>
        {/* world-map */}
      </>
    );
  }
}

export default App;
